<div class="filter-container">
  <!-- Currency Filter -->
  <div id="currency-filter" class="filter-holder">
    <va-currency-select
      size="small"
      labelPlacement="top"
      selectWidth="78"
      [bottomBorderView]="true"
      [suggestedCurrencies]="currencyOptionList"
      [selectedCurrency]="selectedCurrency"
      [apiEP]="apiEP"
      apiUrl="/api/get_available_currencies"
      (onChange)="onCurrencyChange($event)"
    ></va-currency-select>
  </div>
  <div class="filter-holder">
    <div
      *ngIf="!yearType"
      [ngStyle]="{ width: chartTypeId === 1 ? '106px' : '185px' }"
    >
      <nz-skeleton
        [nzTitle]="true"
        [nzActive]="true"
        [nzParagraph]="false"
      ></nz-skeleton>
    </div>
    <va-period-filter
      *ngIf="yearType"
      [periodData]="yearType ? yearType : undefined"
      [disabled]="!metaReady"
      [filterWidthVariation]="chartTypeId === 2 ? 3 : 1"
      (onApply)="saveChartsYearType($event)"
      [dataAvailable]="periodsWithAvailableData"
    >
    </va-period-filter>
  </div>

  <!-- <div
    id="yeartype-filter"
    class="filter-holder"
    *ngIf="chartTypeId == null || chartTypeId === 1 || chartTypeId === 2"
  >
    <div
      *ngIf="yearType === null && tsYearType === null"
      [ngStyle]="{ width: chartTypeId === 1 ? '106px' : '185px' }"
    >
      <nz-skeleton
        [nzTitle]="true"
        [nzActive]="true"
        [nzParagraph]="false"
      ></nz-skeleton>
    </div>
    <app-charts-year-type-filter
      *ngIf="yearType !== null || tsYearType !== null"
      [filterData]="filterData"
      (saveYearType)="saveChartsYearType($event)"
      (setPeriod)="setCompsPeriod($event)"
      [chartType]="chartType"
      [yearType]="yearType"
      [tsYearType]="tsYearType"
      [createComp]="false"
    ></app-charts-year-type-filter>
  </div> -->

  <!-- Data View Filter -->
  <div
    id="dataview-filter"
    class="filter-holder"
    *ngIf="chartTypeId == null || chartTypeId === 1 || chartTypeId === 2"
  >
    <div *ngIf="selectedDataView === null" style="width: 130px;">
      <nz-skeleton
        [nzTitle]="true"
        [nzActive]="true"
        [nzParagraph]="false"
      ></nz-skeleton>
    </div>
    <app-single-select-dropdown
      *ngIf="selectedDataView !== null"
      (callback)="onDataViewChange($event)"
      [label]="'Values or YoY%'"
      [items]="dataViewList"
      width="100px"
      [selectedItem]="selectedDataView"
    >
    </app-single-select-dropdown>
  </div>

  <!-- Revision Period Filter -->
  <div
    class="filter-holder"
    *ngIf="chartTypeId && chartTypeId === 3"
    id="revisionsperiod-filter"
  >
    <div *ngIf="!selectedRevision" style="width: 100px;">
      <nz-skeleton
        [nzTitle]="true"
        [nzActive]="true"
        [nzParagraph]="false"
      ></nz-skeleton>
    </div>
    <app-revision-period-select
      *ngIf="selectedRevision"
      [selectedRevision]="selectedRevision"
      (onChange)="onRevisionChange($event)"
      [createChart]="'false'"
    ></app-revision-period-select>
  </div>

  <!-- Revision Period Filter -->
  <!-- Scale Type Filter -->
  <div id="scaletype-filter" class="filter-holder">
    <div *ngIf="selectedScaleType === null" style="width: 100px;">
      <nz-skeleton
        [nzTitle]="true"
        [nzActive]="true"
        [nzParagraph]="false"
      ></nz-skeleton>
    </div>
    <app-single-select-dropdown
      *ngIf="selectedScaleType !== null"
      (callback)="onScaleTypeChange($event)"
      [label]="'Rebase to 100'"
      [items]="scaleTypeList"
      width="118px"
      [selectedItem]="selectedScaleType"
    >
    </app-single-select-dropdown>
  </div>
  <!-- Scale Type Filter -->

  <!-- Estimates Filter -->
  <!-- <div *ngIf="chartTypeId === 3">
    <div *ngIf="selectedEstimates === null" style="width: 170px;">
      <nz-skeleton
        [nzTitle]="true"
        [nzActive]="true"
        [nzParagraph]="false"
      ></nz-skeleton>
    </div>
    <app-estimates-filter
      *ngIf="selectedEstimates !== null"
      [selectedEstimates]="selectedEstimates"
      (onChange)="onChangeEstimates($event)"
    ></app-estimates-filter>
  </div> -->
</div>
